import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../ui/dialog";
import { CountdownTimer } from "./CountdownTimer";
import { CHECKOUT_URL } from "../../data/academyData";

const SHOWN_KEY = "ax_exit_intent_shown";

export const ExitIntentModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let armed = false;
    const armTimer = setTimeout(() => {
      armed = true;
    }, 4000);

    const handleMouseLeave = (e) => {
      if (!armed) return;
      if (sessionStorage.getItem(SHOWN_KEY)) return;
      if (e.clientY <= 0) {
        setOpen(true);
        sessionStorage.setItem(SHOWN_KEY, "1");
      }
    };

    document.addEventListener("mouseleave", handleMouseLeave);
    return () => {
      clearTimeout(armTimer);
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        data-testid="exit-intent-modal"
        className="bg-[#0d0d10] border border-rose-500/30 text-white rounded-3xl max-w-md p-8 shadow-[0_0_60px_rgba(229,9,20,0.3)]"
      >
        <DialogTitle className="sr-only">Founding member offer reminder</DialogTitle>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-rose-400 font-semibold">Wait, Before You Go</p>
        <h3 className="mt-3 font-heading text-2xl sm:text-3xl font-bold leading-tight">Your Founding Spot Is Still Open.</h3>
        <p className="mt-3 text-zinc-400 leading-relaxed">
          21 guides, ongoing 1-on-1 consultation & all future releases — for a one-time ₹999. This founding price disappears after 100 members.
        </p>
        <div className="mt-5 flex items-baseline gap-3">
          <span className="text-zinc-500 line-through">₹9,999</span>
          <span className="font-heading text-4xl font-bold">₹999</span>
        </div>
        <div className="mt-4">
          <CountdownTimer />
        </div>
        <a
          href={CHECKOUT_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="exit-intent-claim-button"
          onClick={() => setOpen(false)}
          className="mt-6 w-full inline-flex items-center justify-center gap-2 rounded-full bg-rose-600 hover:bg-rose-500 text-white font-semibold text-base px-6 py-4 transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(229,9,20,0.45)]"
        >
          Claim My Founding Spot <ArrowRight size={18} />
        </a>
      </DialogContent>
    </Dialog>
  );
};
